import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../../../styles/medics.scss';
import Input from '../../../components/elements/input/Input';
import agentService from '../../../api/agent-api';
import { toast } from 'react-toastify';
import { Alert, Button } from 'antd';
import ContentLayout from '../../../layout/ContentLayout';

const EditAgent = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);

  const toggleShowPassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    referralCode: '',
    password: '',
  });

  const handleFetchAgent = async () => {
    const { data, success, message } = await agentService.getDetails(id);

    if (!success) {
      toast.error(message || 'Greška pri učitavanju podataka o agentu.');
      return;
    }

    setData({
      _id: data._id,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      referralCode: data.referralCode || '',
    });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const validateInputs = () => {
    const { firstName, lastName, email, password } = data;
    if (!firstName.trim()) {
      setError('Unesite ime agenta.');
      return false;
    }
    if (!lastName.trim()) {
      setError('Unesite prezime agenta.');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Unesite validnu adresu e-pošte.');
      return false;
    }
    if (passwordVisible && (!password || password.length < 8)) {
      setError('Lozinka mora imati najmanje 8 karaktera.');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    const isValid = validateInputs();
    if (!isValid) {
      setLoading(false);
      return;
    }

    toast.loading('Ažuriranje podataka...');

    const payload = passwordVisible
      ? {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          referralCode: data.referralCode,
          newPassword: data.password,
        }
      : {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          referralCode: data.referralCode,
        };

    try {
      const response = await agentService.update(id, payload);

      if (!response.success) {
        toast.dismiss();
        toast.error(response.message || 'Došlo je do greške pri ažuriranju podataka.');
        setLoading(false);
        return;
      }

      toast.dismiss();
      toast.success('Podaci uspešno ažurirani.');
      handleFetchAgent();
    } catch (err) {
      console.error('Error updating agent:', err);
      toast.dismiss();
      toast.error('Došlo je do greške pri ažuriranju podataka.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      handleFetchAgent();
    }
    // eslint-disable-next-line
  }, [id]);

  return (
    <ContentLayout>
      <div className="edit_medic_wrapper">
        <div className="edit_medic_container">
          <div className="edit_medic_header">
            <Link to={'/korisnici?tab=agenti'} className="link_btn" style={{ marginLeft: 0 }}>
              <img alt="back image" src="/assets/icons/chevron.svg" />
              <span>Nazad</span>
            </Link>
          </div>

          <div className="edit_medic_form_container">
            <div className="edit_medic_form_wrapper">
              <div className="form_header">
                <span className="form_title">Uredi nalog agenta</span>
              </div>

              <form className="edit_medic_form">
                <div className="grid_row">
                  <div className="cell">
                    <span className="label">Ime</span>
                    <Input
                      onChange={handleOnChange}
                      name="firstName"
                      id="firstName"
                      value={data.firstName}
                      placeholder="Ime"
                    />
                  </div>

                  <div className="cell">
                    <span className="label">Prezime</span>
                    <Input
                      onChange={handleOnChange}
                      name="lastName"
                      id="lastName"
                      value={data.lastName}
                      placeholder="Prezime"
                    />
                  </div>

                  <div className="cell">
                    <span className="label">Email</span>
                    <Input
                      onChange={handleOnChange}
                      name="email"
                      id="email"
                      value={data.email}
                      placeholder="Email"
                    />
                  </div>

                  <div className="cell">
                    <span className="label">Referral kod</span>
                    <Input
                      onChange={handleOnChange}
                      name="referralCode"
                      id="referralCode"
                      value={data.referralCode}
                      placeholder="Referral kod"
                    />
                  </div>

                  <div className="cell">
                    {passwordVisible ? (
                      <>
                        <span className="label">Lozinka</span>
                        <Input
                          onChange={handleOnChange}
                          name="password"
                          id="password"
                          value={data.password || ''}
                          placeholder="*******"
                          type="password"
                        />
                      </>
                    ) : (
                      <span className="value">*******</span>
                    )}
                  </div>
                  <div className="cell">
                    <div className="reset_password_wrapper">
                      <button
                        type="button"
                        className="link_btn"
                        style={{ marginLeft: 0 }}
                        onClick={toggleShowPassword}
                      >
                        <span>Resetuj lozinku</span>
                      </button>
                    </div>
                  </div>
                </div>

                {error && (
                  <Alert
                    message={error}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                  />
                )}

                <div className="row">
                  <div className="submit_wrapper">
                    <Button
                      className="primary_btn"
                      type="button"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      <span>{loading ? 'Učitavanje...' : 'Sačuvaj izmene'}</span>
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default EditAgent;
